module.exports = __webpack_public_path__ + "static/media/support-small-placeholder.5a561e60.webp";